import {SelectableItem} from 'airship/patterns/select'
import {getCurrentUrlEU, getCurrentUrlUS} from 'airship/utils/region-urls'

export const RegionItems: SelectableItem[] = [
  {
    label: '🇺🇸 US',
    id: getCurrentUrlUS(),
  },
  {
    label: '🇪🇺 EU',
    id: getCurrentUrlEU(),
  },
]
